import Section from './Section';

class PnpItem {
  private _name: string;
  private _section!: Section;
  private readonly _attributes: Map<string, string> = new Map<string, string>();

  constructor(name: string) {
    this._name = name;
  }

  get attributes(): Map<string, string> {
    return this._attributes;
  }

  addAttribute(key: string, value: string) {
    this._attributes.set(key, value);
  }

  set name(value: string) {
    this._name = value;
  }

  get name(): string {
    return this._name;
  }

  get section(): Section {
    return this._section;
  }

  set section(value: Section) {
    this._section = value;
  }
}

export default PnpItem;
